import { render, staticRenderFns } from "./CustomBreadcrumb.vue?vue&type=template&id=90dcbfd0&"
import script from "./CustomBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./CustomBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports